import { extractFieldErrors, normalizeApiError } from "helpers/apiError";

const SERVER_FIELD_TO_FORM_FIELD: Record<string, string> = {
  user_load_number: "userLoadNumber"
};

export interface PostLoadFieldError {
  name: string;
  message: string;
}

export interface PostLoadErrorResolution {
  fieldErrors: PostLoadFieldError[];
  message: string;
}

export const resolvePostLoadError = (error: unknown, fallback: string): PostLoadErrorResolution => {
  const fieldErrors = Object.entries(extractFieldErrors(error)).flatMap(([field, messages]) => {
    const name = SERVER_FIELD_TO_FORM_FIELD[field];

    return name ? [{ name, message: messages.join(" ") }] : [];
  });

  return {
    fieldErrors,
    message: normalizeApiError(error, { fallback }).message
  };
};
